export default __webpack_public_path__ + "static/media/boxbgmega.9af0fecf.png";